import { Stack, Typography } from '@mui/material';
import { ts, ts2 } from 'src/utils/translate';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';

interface RoomRecognitionLimitReachedModalProps {
    monthlyLimit: number;
    onContinue: () => void;
}

export function RoomRecognitionLimitReachedModal({ monthlyLimit, onContinue }: RoomRecognitionLimitReachedModalProps) {
    return (
        <BaseDialog
            onClose={onContinue}
            hideClose
            title={`🚫 ${ts('room_recognition_limit_reached_title', 'Automatic room recognition limit reached')}`}
            titleColor="error.main"
            actionLabel={ts('continue_button_label', 'Continue')}
            onAction={onContinue}
        >
            <Stack spacing={1.25} sx={{ textAlign: 'center', mx: 'auto', maxWidth: 450 }}>
                <Typography>
                    {ts2(
                        'room_recognition_limit_reached_used_all',
                        "You've used all {limit} automatic room recognitions available this month.", { limit: monthlyLimit.toString() }
                    )}
                </Typography>
                <Typography>
                    {ts('room_recognition_limit_reached_draw_manually', 'For now, you can continue by drawing the rooms manually.')}
                </Typography>
                <Typography>
                    {ts('room_recognition_limit_reached_resets', 'Your monthly limit will reset next month.')}
                </Typography>
            </Stack>
        </BaseDialog>
    );
}
